import { NominationWebsite, NominationWebsiteRef } from '../../models';
import { FetchContext } from '../fetch-context';
import { responseErrorHandler } from '../response-error-handler';

export const createNominationWebsite: (
  fetchContext: FetchContext,
  nominationId: number,
  nominationWebsite: NominationWebsite,
  accessToken?: string,
) => Promise<NominationWebsiteRef> = (fetchContext, nominationId, nominationWebsite, accessToken) =>
  fetch(`${fetchContext.baseUrl}/api/nominations/${nominationId}/websites`, {
    method: 'POST',
    body: JSON.stringify(nominationWebsite),
    headers: {
      Authorization: `Bearer ${accessToken}`,
      'Content-Type': 'application/json',
    },
  })
  .then((response) => responseErrorHandler<NominationWebsiteRef>(fetchContext.errorStore, response, 'create nomination website'));
